export const step2 = {
  businessTypeList: [
    {
      icon: '//static.mybuild.co.kr/type01.svg',
      title: '교육, 연구',
      value: '교육/연구',
    },
    {
      icon: '//static.mybuild.co.kr/type02.svg',
      title: '광고, 마케팅',
      value: '광고/마케팅',
    },
    {
      icon: '//static.mybuild.co.kr/type03.svg',
      title: '제조업',
      value: '제조업',
    },
    {
      icon: '//static.mybuild.co.kr/type04.svg',
      title: '디자인, 설계',
      value: '디자인/설계',
    },
    {
      icon: '//static.mybuild.co.kr/type05.svg',
      title: '금융, 투자',
      value: '금융/투자',
    },
    {
      icon: '//static.mybuild.co.kr/type06.svg',
      title: '부동산, 건설',
      value: '부동산/건설',
    },
    {
      icon: '//static.mybuild.co.kr/type07.svg',
      title: '여행, 요양',
      value: '여행/요양',
    },
    {
      icon: '//static.mybuild.co.kr/type08.svg',
      title: '스포츠, 레저',
      value: '스포츠/레저',
    },
    {
      icon: '//static.mybuild.co.kr/type09.svg',
      title: '방송, 예술, 출판',
      value: '방송/예술/출판',
    },
    {
      icon: '//static.mybuild.co.kr/type10.svg',
      title: '쇼핑몰, 도소매',
      value: '쇼핑몰/도소매',
    },
    {
      icon: '//static.mybuild.co.kr/type11.svg',
      title: 'IT개발, 정보통신',
      value: 'IT개발/정보통신',
    },
    {
      icon: '//static.mybuild.co.kr/type12.svg',
      title: '사업지원, 컨설팅',
      value: '사업지원/컨설팅',
    },
    {
      icon: '//static.mybuild.co.kr/type13.svg',
      title: '물류, 운송, 보관',
      value: '물류/운송/보관',
    },
    {
      icon: '//static.mybuild.co.kr/type14.svg',
      title: '요식업, 웨딩',
      value: '요식업/웨딩',
    },
    {
      icon: '//static.mybuild.co.kr/type15.svg',
      title: '기타 (상담 후 결정)',
      value: '기타 (상담 후 결정)',
    },
  ],

  customChecked: ['custom'],

  get checkedItemCount() {
    return this.userInput.businessTypes.length;
  },

  get isNextBtnActive() {
    return (
      this.checkedItemCount > 0 || this.userInput.customBusinessType !== ''
    );
  },

  checkedChanged(item: any) {
    if (this.checkedItemCount >= 4) {
      this.userInput.businessTypes.splice(
        this.userInput.businessTypes.indexOf(item.value),
        1,
      );
    }
  },
};
